import Clock from './Clock';

export default Clock;


// WEBPACK FOOTER //
// ./src/components/Clock/index.js